import { MessageSquare } from 'lucide-react'
import { FormattedMessage } from 'v2/shared/components/formatted-message'
import type { RFileUploadResponse } from 'v2/types/api/auth'
import { MessageImages } from '../../event-interface/message-images'

interface UserMessageProps {
  text: string
  files?: Array<RFileUploadResponse>
}

export const UserMessage = ({ text, files }: UserMessageProps) => (
  <div className="flex flex-col gap-1.5">
    <span className="inline-flex items-center gap-2 text-h4-500 text-primary">
      <MessageSquare className="size-4 text-brand-text" />
      User Message
    </span>
    <div className="font-inter text-s-400 text-primary">
      <FormattedMessage content={text} markdown className="text-s-400 text-primary" />
    </div>
    {files && <MessageImages files={files} />}
  </div>
)
